import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "fixed inset-0 z-50 overflow-x-hidden vue-modal-background"
};
const _hoisted_2 = {
  class: "bg-gray-50 w-4/12 shadow-lg rounded-sm absolute top-44 right-1/4 p-6"
};
import UpdateSubject from "./UpdateSubject.vue";
export default {
  __name: 'UpdateSubjectModal',
  props: {
    reminderMode: {
      type: Number,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(UpdateSubject, {
        "reminder-mode": __props.reminderMode,
        alerts: __props.alerts
      }, null, 8, ["reminder-mode", "alerts"])])]);
    };
  }
};